import { Component, inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";

@Component({
  selector: "app-expire-video",
  imports: [SharedModule],
  templateUrl: "./expire-video.component.html",
  styleUrl: "./expire-video.component.scss",
})
export class ExpireVideoComponent {
  #dialogRef = inject(MatDialogRef<ExpireVideoComponent>);
  #router = inject(Router);

  ngOnInit(): void {}

  onSubmit() {
    this.#router.navigateByUrl("/online-class");
    this.#dialogRef.close();
  }
}
